"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _Caption = _interopRequireDefault(require("./Caption"));

var _Input = _interopRequireDefault(require("./Input"));

var _utils = require("../utils");

var _theme = require("../theme");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MediaImage = function MediaImage(props) {
  var file = props.file,
      onSelect = props.onSelect,
      onDelete = props.onDelete,
      onUpdate = props.onUpdate;

  var _ref = (0, _react.useState)(_objectSpread({}, file)),
      _ref2 = _slicedToArray(_ref, 2),
      data = _ref2[0],
      setData = _ref2[1];

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      loading = _ref4[0],
      setLoading = _ref4[1];

  (0, _react.useEffect)(function () {
    setData(file);
  }, [file]);

  var handleChange = function handleChange(e) {
    return setData(_objectSpread(_objectSpread({}, data), {}, _defineProperty({}, e.target.name, e.target.value)));
  };

  var handleUpdateMediaItem = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading('update');
              onUpdate(data);
              setLoading(false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdateMediaItem() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handlDeleteMediaItem = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading('delete');
              _context2.next = 3;
              return onDelete();

            case 3:
              setLoading(false);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handlDeleteMediaItem() {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [16, 16]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12,
    style: {
      background: "".concat(_theme.colors.secondaryContrast)
    }
  }, /*#__PURE__*/_react.default.createElement(ImageContainer, null, (0, _utils.renderImage)(file))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(Content, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8],
    align: "middle"
  }, (data === null || data === void 0 ? void 0 : data.filename) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "File name"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 18
  }, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
    children: data.filename
  }))), (data === null || data === void 0 ? void 0 : data.type) && (data === null || data === void 0 ? void 0 : data.subtype) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Type"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 18
  }, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
    children: "".concat(data.type, "/").concat(data.subtype)
  }))), (data === null || data === void 0 ? void 0 : data.filesize) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "File size"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 18
  }, /*#__PURE__*/_react.default.createElement(_antd.Typography, {
    children: (0, _utils.convertFileSize)(data.filesize)
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Dimensions"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 18
  }, /*#__PURE__*/_react.default.createElement(_antd.Typography, null, (data === null || data === void 0 ? void 0 : data.width) > 0 && (data === null || data === void 0 ? void 0 : data.height) > 0 ? "".concat(data.width, " by ").concat(data.height, " pixels") : 'Not available'))), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Alternative Text",
    value: data.altText,
    onChange: handleChange,
    name: "altText"
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Url",
    value: data.url,
    onChange: function onChange() {},
    name: "url",
    disabled: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Typography.Paragraph, {
    copyable: {
      text: data.sourceUrl
    },
    children: 'Copy Link'
  }))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, null, /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    title: "Are you sure?",
    onConfirm: handlDeleteMediaItem,
    okText: "Yes",
    cancelText: "No"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Delete",
    danger: true,
    loading: loading === 'delete'
  })), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: handleUpdateMediaItem,
    children: "Update Image",
    loading: loading === 'update'
  }))), onSelect && /*#__PURE__*/_react.default.createElement(_antd.Col, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: function onClick() {
      return onSelect(file);
    },
    children: "Select",
    type: "primary"
  })))))));
};

var ImageContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 400px;\n  background: #fff;\n  border: 1px solid #d9d9d9;\n"])));

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  min-height: 300px;\n"])));

var _default = MediaImage;
exports.default = _default;